<template>
  <div>
    <v-dialog v-model="remarkDialog" max-width="450">
      <v-card>
        <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold">A/S 관리 내역 입력</v-card-title>

        <v-card-text class="px-5 pb-0">
          <p class="mb-0 primary--text">접수번호 : {{ receiptNo }}</p>
          <p class="mt-1">수리 금액, 운송장번호, 메모 정보를 입력해 주세요.</p>
        </v-card-text>

        <div class="px-5 pt-3">
          <p class="mb-1">수리금액</p>
          <v-text-field v-model="repairAmount" outlined dense placeholder="숫자만 입력" @keydown="M.checkNumber"></v-text-field>

          <p class="mb-1">운송장번호</p>
          <v-text-field v-model="trackingNo" outlined dense placeholder="운송장번호 입력"></v-text-field>

          <p class="mb-1">메모</p>
          <v-textarea v-model="memo" outlined no-resize full-width hide-details height="200"></v-textarea>
        </div>

        <div v-if="updatedAt" class="px-5 pb-0 pt-2">
          <p class="mb-0 caption">마지막 저장 일시 : {{ updatedAt }}</p>
        </div>

        <v-card-actions class="px-5 pb-5">
          <v-btn color="black" class="white--text" @click="remarkDialog = false" width="49%">닫기</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="save" width="49%">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      M,
      remarkDialog: false,
      receiptNo: null,
      repairAmount: "",
      trackingNo: "",
      memo: "",
      updatedAt: "",
    };
  },
  mixins: [CommonMixin],
  methods: {
    reset() {
      Object.assign(this.$data, this.$options.data());
    },
    show(item) {
      this.reset();
      this.receiptNo = item.receipt_no;
      this.repairAmount = item.remark && typeof item.remark.repair_amount !== "undefined" ? item.remark.repair_amount : "";
      this.trackingNo = item.remark && item.remark.tracking_no ? item.remark.tracking_no : "";
      this.memo = item.remark && item.remark.memo ? item.remark.memo : "";
      this.updatedAt = item.remark && item.remark.updated_at ? item.remark.updated_at : "";
      this.remarkDialog = true;
    },
    async save() {
      try {
        const payload = {
          repair_amount: this.repairAmount === "" ? null : Number(this.repairAmount),
          tracking_no: this.trackingNo,
          memo: this.memo,
        };
        const result = await M.api(M.entry("/as/remark", this.receiptNo), payload);
        const remarkData = result && result.remark ? result.remark : payload;
        if (this.$parent && typeof this.$parent.setRemark === "function") {
          this.$parent.setRemark(this.receiptNo, remarkData);
        } else {
          this.$emit("saved", this.receiptNo, remarkData);
        }
        this.alertShow("저장되었습니다.");
        this.remarkDialog = false;
      } catch (e) {
        console.log("save remark error", e);
        this.alertShow("저장에 실패했습니다. 잠시 후 다시 시도해주세요.");
      }
    },
  },
};
</script>
